import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PersonExport, PersonImport } from '../models/person-import';
import { BaseEntityService } from '../entity-management/services/base/base-entity.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { RouterParamsService } from '../../shared/services/router-params.service';
import { DateService } from '../../shared/services/date.service';

@Injectable({
  providedIn: 'root',
})
export class PersonImportEntityService extends BaseEntityService<PersonImport> {

  constructor(
    httpClient: HttpClient,
    routerParamsService: RouterParamsService,
    private dateService: DateService,
  ) {
    super(
      httpClient,
      environment.apiUrl, { singular: 'personImport', plural: 'personImports', url: 'person-imports' },
      routerParamsService
    );
    this.nameId = 'personImportId';
  }


  userOpinionExport(userOpinionExport: any): Observable<PersonExport> {
    console.log(userOpinionExport);


    if (userOpinionExport?.createdAtMin) {
      console.log(this.dateService.dateToString(
        userOpinionExport?.createdAtMin,
      ));


      userOpinionExport.createdAtMin = this.dateService.dateToString(
        userOpinionExport?.createdAtMin,
      );
    }


    const body = {
      userOpinionExport
    };
    return this.httpClient
      .post([environment.apiUrl, 'user-opinion-exports'].join('/'), body)
      .pipe(map((response: any) => response?.userOpinionExport));
  }

  personExport(organizationId: any): Observable<PersonExport> {
    const body = {
      personExport: {
        organization: { id: organizationId },
        type: 'FULL',
      },
    };
    return this.httpClient
      .post([environment.apiUrl, 'person-exports'].join('/'), body)
      .pipe(map((response: any) => response?.personExport));
  }

  personImport(values: any): Observable<PersonExport> {
    const body = { personImport: values };
    return this.httpClient
      .post([environment.apiUrl, 'person-imports'].join('/'), body)
      .pipe(map((response: any) => response?.personImport));
  }

  personManagerImport(values: any): Observable<PersonExport> {
    const body = { managerImport: values };
    return this.httpClient
      .post([environment.apiUrl, 'manager-imports'].join('/'), body)
      .pipe(map((response: any) => response?.personImport));
  }

  personInactivate(values: any): Observable<PersonExport> {
    const body = { personImport: values };
    return this.httpClient
      .post([environment.apiUrl, 'person-imports', 'inactivate'].join('/'), body)
      .pipe(map((response: any) => response?.personImport));
  }
}
